import React from "react"
import { withRouter } from "react-router"
import shop from "shop/shop"
import settingStore from "stores/settingStore"
import { extractOrderMode, buildOrderModeSwitchUrl, ORDER_MODE_SWITCH_PATH } from "../../shop/orderMode"

// Wertet ?orderMode=sofort|vororder bei Navigation innerhalb des Shops aus (z.B. Link im CMS-Inhalt).
// Beim direkten Aufruf eines Links greift bereits rewriteInitialOrderModeUrl() in App.js.
@withRouter
export default class OrderModeLinkHandler extends React.Component {

  componentDidMount() {
    this.check()
  }

  componentDidUpdate( prevProps ) {
    if ( prevProps.location !== this.props.location ) this.check()
  }

  check() {
    const { location, history } = this.props
    const { pathname } = location
    if ( !shop.session || pathname.startsWith( "/login" ) || pathname.startsWith( ORDER_MODE_SWITCH_PATH ) ) return

    const rawTarget = `${pathname}${location.search}`
    const { url: target, mode } = extractOrderMode( rawTarget )
    if ( target === rawTarget ) return

    if ( !mode || mode === settingStore.get( "orderMode" ) ) {
      history.replace( target )
    } else {
      history.replace( buildOrderModeSwitchUrl( mode, target ) )
    }
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/components/OrderMode/OrderModeLinkHandler.js